import { z } from 'zod';
export const ItemIdEnumSchema = z.enum(['tarping']);
export const ItemId = ItemIdEnumSchema.enum;
